var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "model-task-table_container" },
    [
      _c(
        "table-custom",
        {
          ref: "taskTable",
          staticClass: "model-task-table",
          attrs: {
            data: _vm.tableData,
            selection: "",
            "row-key": "rtId",
            "expand-row-keys": _vm.expands,
            "tree-props": { children: "subTasks", hasChildren: "hasChildren" },
            "selected-list": _vm.checkedList,
            "column-width": "400",
            disabled:
              (_vm.isSingle && _vm.checkedList.length > 0) ||
              _vm.checkedList.length >= _vm.limit,
            "disabled-list": _vm.disabledList.concat(_vm.relatedTasks),
            "default-expand-all": "",
            height: _vm.tableHeight,
            "column-label": "pc_biz_jq_lbl_taskName",
          },
          on: { "selection-change": _vm.handleSelectionChange },
        },
        [
          _c("yxt-table-column", {
            attrs: {
              label: _vm.$t("pc_biz_udp_lbl_description"),
              "show-overflow-tooltip": "",
              prop: "taskDesc",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _vm._v(
                      "\n        " + _vm._s(row.taskDesc || "--") + "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c("gwnl-pager", {
        attrs: { pager: _vm.pager },
        on: { searchData: _vm.getModelDuty },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }